import { render, staticRenderFns } from "./CondutorForm.vue?vue&type=template&id=48770a1a&scoped=true"
import script from "./CondutorForm.vue?vue&type=script&lang=js"
export * from "./CondutorForm.vue?vue&type=script&lang=js"
import style0 from "./CondutorForm.vue?vue&type=style&index=0&id=48770a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48770a1a",
  null
  
)

export default component.exports